import { NavigateFunction } from 'react-router-dom';

export interface NavigationAction {
  route: string;
  autoFocus?: string; // ID of element to focus
  autoClick?: string; // ID of element to click
  searchFocus?: boolean; // Focus on search bar
  addButtonClick?: boolean; // Click add/create button
}

export const navigateWithAction = (navigate: NavigateFunction, action: NavigationAction) => {
  navigate(action.route, { 
    state: { 
      focusSearch: action.searchFocus,
      addModal: action.addButtonClick 
    } 
  });
  
  // Use a small delay to ensure the page has rendered
  setTimeout(() => {
    if (action.searchFocus) {
      // Prioritize LOCAL search bar over global
      const searchSelectors = [
        '[data-search="local"]', // LOCAL search bar first
        'input[placeholder*="candidates" i]',
        'input[placeholder*="search candidates" i]',
        'input[placeholder*="search" i]',
        'input[placeholder*="filter" i]',
        'input[type="search"]',
        '.search-input',
        '#search',
        '[data-search]'
      ];
      
      for (const selector of searchSelectors) {
        const element = document.querySelector(selector) as HTMLInputElement;
        if (element) {
          element.focus();
          element.select();
          console.log('🎯 Focused LOCAL search:', selector);
          break;
        }
      }
    }
    
    if (action.addButtonClick) {
      // Look for common add/create button patterns
      const addButtonSelectors = [
        'button[data-add]',
        'button[data-create]',
        'button:has([data-lucide="plus"])',
        'button:contains("Add")',
        'button:contains("Create")',
        '[data-add-button]',
        '.add-button',
        '#add-button'
      ];
      
      for (const selector of addButtonSelectors) {
        const element = document.querySelector(selector) as HTMLButtonElement;
        if (element) {
          element.click();
          break;
        }
      }
    }
    
    if (action.autoFocus) {
      const element = document.getElementById(action.autoFocus) as HTMLElement;
      if (element) {
        element.focus();
        if (element instanceof HTMLInputElement) {
          element.select();
        }
      }
    }
    
    if (action.autoClick) {
      const element = document.getElementById(action.autoClick) as HTMLElement;
      if (element) {
        element.click();
      }
    }
  }, 100);
};

// Pre-defined navigation actions
export const NavigationActions = {
  searchCandidates: {
    route: '/candidates',
    searchFocus: true
  } as NavigationAction,
  
  addCandidate: {
    route: '/cv-builder'
  } as NavigationAction,
  
  scheduleAppointment: {
    route: '/appointments',
    addButtonClick: true
  } as NavigationAction,
  
  assignTask: {
    route: '/tasks',
    addButtonClick: true
  } as NavigationAction,
  
  createCV: {
    route: '/cv-builder'
  } as NavigationAction,
  
  viewJobs: {
    route: '/jobs'
  } as NavigationAction,
  
  jobGenerator: {
    route: '/job-generator'
  } as NavigationAction,
  
  searchTasks: {
    route: '/tasks',
    searchFocus: true
  } as NavigationAction,
  
  searchAppointments: {
    route: '/appointments',
    searchFocus: true
  } as NavigationAction
};